import { useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { useGetUsers, useGetTeams } from "security-app/hooks/useInvestigationsAPI";
const useUsersAndTeams = () => {
  const { users } = useGetUsers(true);
  const { teams } = useGetTeams(true);
  const { id: currentUserId, firstName, lastName } = useCurrentUser();
  const currentUserFullName = currentUserId.endsWith("admin") ? "Administrator" : `${firstName} ${lastName}`;
  return useMemo(
    () => ({
      [currentUserId]: { label: currentUserFullName, type: "user", id: currentUserId },
      ...Object.fromEntries(
        users.map((user) => [user.id, { label: user.full_name, type: "user", id: user.id }])
      ),
      ...Object.fromEntries(
        teams.map((team) => [team.id, { label: team.name, type: "team", id: team.id }])
      )
    }),
    [users, teams, currentUserId, currentUserFullName]
  );
};
export default useUsersAndTeams;
